import React from 'react';
import { connect } from 'react-redux';

import {
  fetchWpJsonApiData,
  sidebarOpen,
} from '../actions';

import App from '../components/App';

const mapStateToProps = (state) => {
  return {
    sidebar: state.sidebar.open,
    width: state.browser.width,
    trailheadsToggled: state.sidebar.trailheads,
    trips: state.tripsTrailheads.trips,
    trailheads: state.tripsTrailheads.trailheads,
    selected: state.tripsTrailheads.selected,
    measuredDistance: state.distanceReadout.distance,
  };
}

export default connect(mapStateToProps, {
  fetchWpJsonApiData,
  sidebarOpen,
})(App);



// WEBPACK FOOTER //
// ./map/containers/AppConnected.js